export const PLANNING_GRID_ID = 1;
export const ANOMALY_GRID_ID = 2;

export const CORRECTIVE_GRID_HTML_ID = 'correctives-grid';
